/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

document.addEventListener("DOMContentLoaded", function() {
  var logos = [
    "https://cdn.shopify.com/s/files/1/0947/5325/9843/files/Meredith-House-logo-Blink.png?v=1757327003",
    "https://cdn.shopify.com/s/files/1/0947/5325/9843/files/Meredith-House-logo-Rebel.png?v=1757327004",
    "https://cdn.shopify.com/s/files/1/0947/5325/9843/files/Meredith-House-logo-Dora.png?v=1757327003",
    "https://cdn.shopify.com/s/files/1/0947/5325/9843/files/Meredith-House-logo-Elf.png?v=1757327004",
    "https://cdn.shopify.com/s/files/1/0947/5325/9843/files/Meredith-House-logo-Riot.png?v=1757327004",
    "https://cdn.shopify.com/s/files/1/0947/5325/9843/files/Meredith-House-logo-Petal.png?v=1757327003",
    "https://cdn.shopify.com/s/files/1/0947/5325/9843/files/Meredith-House-logo-Selma.png?v=1757327003",
    "https://cdn.shopify.com/s/files/1/0947/5325/9843/files/Meredith-House-logo-Loulou.png?v=1757327003",
    "https://cdn.shopify.com/s/files/1/0947/5325/9843/files/Meredith-House-logo-Peach.png?v=1757327003",
    "https://cdn.shopify.com/s/files/1/0947/5325/9843/files/Meredith-House-logo-Birdie.png?v=1757327003"
  ];

  var storeDefaultLogo = "https://cdn.shopify.com/s/files/1/0947/5325/9843/files/Meredith-House-logo-stamp.png?v=1759224769";
  var lastLogo = null;

  function swapLogo() {
    var logoEls = document.querySelectorAll("#site-logo, [data-site-logo] img, .header__logo img");
    if (!logoEls.length) return;

    // Pick a random logo that isn’t the last one
    var alternateLogos = logos.filter(url => url !== lastLogo);
    var randomLogo = alternateLogos[Math.floor(Math.random() * alternateLogos.length)];

    logoEls.forEach(function(logoEl) {
      logoEl.src = randomLogo;
      if (logoEl.srcset) {
        logoEl.srcset = randomLogo + " 1x, " + randomLogo + " 2x";
      }
    });

    lastLogo = randomLogo;
  }

  // First page visit
  if (!sessionStorage.getItem('firstPageLoaded')) {
    sessionStorage.setItem('firstPageLoaded', 'true');

    var logoEls = document.querySelectorAll("#site-logo, [data-site-logo] img, .header__logo img");
    logoEls.forEach(function(logoEl) {
      logoEl.src = storeDefaultLogo;
      if (logoEl.srcset) {
        logoEl.srcset = storeDefaultLogo + " 1x, " + storeDefaultLogo + " 2x";
      }
    });

    return; // do not swap on first page
  }

  // Subsequent pages: swap logo **once**
  var observer = new MutationObserver(function(mutations, obs) {
    var logoEls = document.querySelectorAll("#site-logo, [data-site-logo] img, .header__logo img");
    if (logoEls.length && logoEls[0].complete) {
      swapLogo();
      obs.disconnect(); // ensure it runs only once per page
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
});



  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
